import { render, staticRenderFns } from "./uploadFolder.vue?vue&type=template&id=f2b384e8&"
import script from "./uploadFolder.vue?vue&type=script&lang=js&"
export * from "./uploadFolder.vue?vue&type=script&lang=js&"
import style0 from "./uploadFolder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports